module.exports = __webpack_public_path__ + "static/media/down.26a3340b.png";